import { MenuItem, Select as SelectMUI, TextField } from '@material-ui/core'
import React, { useCallback, useEffect, useState } from 'react'
import { mdiFilePdfBox, mdiMagnify, mdiPlusCircle } from '@mdi/js'
import { Formik, Form as FormikContainer } from 'formik'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { useAppSelector } from '../../../../store/hooks'
import { setFieldFiltered, setFieldFilteredFlagAtivo, setListaFiltered } from '../../../../store/reducers/default/AmostradorReducer'
import TableListar  from './Components/TableListarAmostradorComponents'
import filter from './Scripts/filter'
import send from './Scripts/send'
import remove from './Scripts/remove'
import Form from '../../../../components/Form'
import Select from '../../../../components/Select'
import Section, { SectionBox, SectionOption } from '../../../../components/Section'
import Modal from '../../../../components/Modal'
import get from './Scripts/get'
import { activeItems } from '../../../../constants/selects'
import edit from './Scripts/edit'

const Amostrador: React.FC = () => {

    const dispatch = useDispatch()
    const { currentData, lista, requestGet, requestSave, requestEdit, requestRemove, fieldFiltered, filteredLista, fieldFilteredFlagAtivo, requestFilter } = useAppSelector(state => state.AmostradorReducer)
    const { userData } = useAppSelector(state => state.auth)

    const [openCriar, setOpenCriar] = useState<boolean>(false)
    const [openEditar, setOpenEditar] = useState<boolean>(false)
    const [openRemover, setOpenRemover] = useState<boolean>(false)
    const [flagAtivo, setFlagAtivo] = useState<string>('1')

    const API_CONTROLLER = "Amostrador"
    const PAGE_NAME = "Amostradores"
    const SHOW_TABLE = !!lista
    const SHOW_FILTERED = SHOW_TABLE && !!filteredLista && requestFilter.data

    const FormActions: React.FC <{label: string}> = ({ label }) => {
        const isLoading = requestEdit.loading || requestRemove.loading || requestSave.loading
        return(
            <div className = "modalBoxMainActionsContainer">
                <button type = "reset" className = "outline" onClick = {() => handleFecharModal()}>Cancelar</button>
                <button type = "submit" className = {`default ${isLoading ? 'status disabled' : ''}`}>{isLoading && <div className = "spinner" />}{label}</button>
            </div>
        )
    }

    const handleFecharModal = useCallback(() => {
        setOpenCriar(false)
        setOpenEditar(false)
        setOpenRemover(false)
        setFlagAtivo('1')
    }, [])

    const handleCriar = useCallback(async (values: {codigo: string, descricao: string, obs: string, dtAquisicao: string}) => {
        await send(API_CONTROLLER, dispatch, {...values, flagAtivo: Number(flagAtivo), idUsuario: userData!.id})
        dispatch(setListaFiltered([]))
        handleFecharModal()
    }, [dispatch, handleFecharModal, flagAtivo, userData])

    const handleEditar = useCallback(async (values: {codigo: string, descricao: string, obs: string, dtAquisicao: string}) => {
        await edit(API_CONTROLLER, dispatch, {...values, flagAtivo: Number(flagAtivo), idUsuario: userData!.id, id: currentData!.id})
        dispatch(setListaFiltered([]))
        handleFecharModal()
    }, [dispatch, handleFecharModal, flagAtivo, currentData, userData])

    const handleRemover = useCallback(async () => {
        dispatch(setListaFiltered([]))
        await remove(API_CONTROLLER, dispatch, {id: currentData!.id, idUsuario: userData!.id})
        handleFecharModal()
    }, [dispatch, handleFecharModal, currentData, userData])
    
    const handleFilter = useCallback(async () => {
        await filter(API_CONTROLLER, dispatch, {descricao: fieldFiltered, flagAtivo: fieldFilteredFlagAtivo})
    }, [dispatch, fieldFiltered, fieldFilteredFlagAtivo])
    
    useEffect(() => {
        (async () => {await get(API_CONTROLLER, dispatch)})()
    }, [dispatch, requestSave.data, requestEdit.data, requestRemove.data])  

    const keyPress =(async (e:any) => {
        if(e.keyCode === 13){
            handleFilter()
         }
    })

    return (
        <>
            <Section name = "Amostrador">
                <SectionBox 
                    title = {PAGE_NAME}
                    padding = {false} 
                    right = {
                        <>
                            <TextField id="filterDescricao" variant="standard" className="fieldFilter" placeholder="Descrição" value={fieldFiltered} onChange={e => dispatch(setFieldFiltered(e.target.value as string))} onKeyDown={keyPress} />
                            <SelectMUI id="filterAtivo" value={fieldFilteredFlagAtivo} onChange={e => dispatch(setFieldFilteredFlagAtivo(e.target.value as any))}>
                                <MenuItem value={'null'}>Todos</MenuItem>
                                <MenuItem value={1}>Habilitado</MenuItem>
                                <MenuItem value={0}>Desabilitado</MenuItem>
                            </SelectMUI>
                            <SectionOption icon = {mdiMagnify} tooltip = "Filtrar" onClick = {handleFilter} />
                            <Link to = "pdf" target = "_blank">
                                <SectionOption icon = {mdiFilePdfBox} tooltip = "Visualizar PDF" onClick = {() => {}} />
                            </Link>
                            <SectionOption icon = {mdiPlusCircle} tooltip = "Criar" onClick = {() => setOpenCriar(true)} />
                        </>
                    }
                >
                    <TableListar lista={SHOW_FILTERED ? filteredLista : lista} loading = {requestGet.loading || requestFilter.loading} setOpenEditar = {setOpenEditar} setOpenRemover={setOpenRemover} />
                </SectionBox>
            </Section>
            <>  
                <Modal width = {1200} open = {openCriar} setOpen = {setOpenCriar} title = "Novo">
                    <Formik initialValues = {{codigo: '', descricao: '', dtAquisicao: '', obs: ''}} onSubmit = {values => handleCriar(values)}>
                        <FormikContainer>
                            <Form.Container padding = {false}>
                                <Form.Row columns = {4} grid = "140px 1fr 180px 140px">
                                    <Form.Group inputID = "codigo" inputName = "codigo" label = "Código" />
                                    <Form.Group inputID = "descricao" inputName = "descricao" label = "Amostrador" />
                                    <Form.Group inputID = "dtAquisicao" inputName = "dtAquisicao" label = "Aquisicao" inputType='date' />
                                    <Select type = "outline" defaultValue={openEditar && currentData ? currentData.flagAtivo.toString() : undefined} value = {flagAtivo} label = "Situação" setValue = {setFlagAtivo} items = {activeItems} />
                                </Form.Row>
                                <Form.Row columns = {1}>
                                    <Form.Group inputID = "obs" inputName = "obs" inputType='textarea' label = "Observações" inputRows = {4} />
                                </Form.Row>
                                <FormActions label = "Adicionar" />
                            </Form.Container>
                        </FormikContainer>
                    </Formik>
                </Modal>
                <Modal width = {1200} open = {openEditar} setOpen = {setOpenEditar} title = "Edição">
                    <Formik initialValues = {{codigo: currentData?.codigo ?? '', descricao: currentData?.descricao ?? '', dtAquisicao: currentData?.dtAquisicao.toString().slice(0, 10) ?? '', obs: currentData?.obs ?? ''}} onSubmit = {values => handleEditar(values)}>
                        <FormikContainer>
                            <Form.Container padding = {false}>
                                <Form.Row columns = {4} grid = "140px 1fr 180px 140px">
                                    <Form.Group inputID = "codigo" inputName = "codigo" label = "Código" />
                                    <Form.Group inputID = "descricao" inputName = "descricao" label = "Amostrador" />
                                    <Form.Group inputID = "dtAquisicao" inputName = "dtAquisicao" label = "Aquisicao" inputType='date' />
                                    <Select type = "outline" defaultValue={openEditar && currentData ? currentData.flagAtivo.toString() : undefined} value = {flagAtivo} label = "Situação" setValue = {setFlagAtivo} items = {activeItems} />
                                </Form.Row>
                                <Form.Row columns = {1}>
                                    <Form.Group inputID = "obs" inputName = "obs" inputType='textarea' label = "Observações" inputRows = {4} />
                                </Form.Row>
                                <FormActions label = "Salvar" />
                            </Form.Container>
                        </FormikContainer>
                    </Formik>
                </Modal>

                <Modal width = {600} open = {openRemover} setOpen = {setOpenRemover} title = "Remover cobrança">
                    <span className = "modalBoxMessage">Deseja remover esse item?</span>
                    <div className = "modalBoxMainActionsContainer">
                        <button className = "outline" onClick = {() => handleFecharModal()}>Cancelar</button>
                        <button className = {`default ${requestRemove.loading ? 'status disabled' : ''}`} onClick = {() => handleRemover()}>{requestRemove.loading && <div className = "spinner" />}Remover</button>
                    </div>
                </Modal>
            </>
        </>
    )
}

export default Amostrador
